import { Role } from '@features/auth/types';

import { paths } from './paths';

type HasRole = (required: readonly Role[] | undefined) => boolean;

/**
 * Role-aware landing route. Admins keep the dashboard; tenants (Händler)
 * land directly on their customer list — the start of the core journey
 * (Kunde → Projekt → Plan). Admin is checked first because admins cannot
 * access the tenant-only customer routes. On a phone the price catalog is
 * the one page built for the small screen, so tenants start there.
 */
export function homePathForRoles(hasRole: HasRole, options: { isPhone?: boolean } = {}): string {
  if (hasRole([Role.Admin])) {
    return paths.dashboard;
  }
  if (options.isPhone) {
    return paths.priceCatalog;
  }
  return paths.projectClients;
}
